import { render, staticRenderFns } from "./pintuan.vue?vue&type=template&id=7de85480&"
import script from "./pintuan.vue?vue&type=script&lang=js&"
export * from "./pintuan.vue?vue&type=script&lang=js&"
import style0 from "./pintuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports